import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Avatar extends React.Component {
  static propTypes = {
    size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']).isRequired,
    src: PropTypes.string,
    name: PropTypes.string,
  }

  static defaultProps = {
    name: '',
  }

  render() {
    const { name, src, size } = this.props;
    const classes = classNames({
     'avatar': true,
     [`avatar--${size}`]: !!size,
    });

    return <img className={classes} src={src} alt={name} itemProp="image" />;
  }
}




// WEBPACK FOOTER //
// ./src/components/avatar.js